import { ActionReducer, MetaReducer } from '@ngrx/store';

export function loggerMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    console.log('%c[Dispatch Action]', 'color: #03A9F4; font-weight: bold;', action);
    const nextState = reducer(state, action);
    return nextState;
  };
}

export const metaReducers: MetaReducer<any>[] = [loggerMetaReducer];
